// extracted by mini-css-extract-plugin
export default {"iconSmall":"ItemTypeIconModal_iconSmall__Z8Lxz"};